var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"check"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"check","fill":"#5DA08E","fillRule":"nonzero"},React.createElement("path",{"d":"M13.5655517,2.34543919 L6.1932069,9.56783784 C5.64727586,10.1028041 4.76168966,10.1028041 4.21524138,9.56783784 L0.409586207,5.83905405 C-0.136551724,5.30408784 -0.136551724,4.43635135 0.409586207,3.90128378 C0.955827586,3.36611486 1.84134483,3.36611486 2.38734483,3.90108108 L5.20451724,6.66118243 L11.5874828,0.407567568 C12.1337241,-0.127601351 13.0193103,-0.127195946 13.5653448,0.407567568 C14.1113793,0.942635135 14.1113793,1.81006757 13.5655517,2.34543919 Z","id":"Path"})))]);
}

Check.defaultProps = {"width":"14px","height":"10px","viewBox":"0 0 14 10","version":"1.1"};

module.exports = Check;

Check.default = Check;
